export default __webpack_public_path__ + "static/media/expo1.327e4aa6.png";